import { editorBlockViewFragment } from '@getaccept/editor-lib';
import gql from 'graphql-tag';

export class DSRQueries {
  static load = gql`
    query dealroom {
      dealroom {
        id
        name
        createdAt
        details {
          expirationDate
          uniqueId
          companyName
          value
        }
        access
      }
    }
  `;

  static loadPages = gql`
    query dealroomPages {
      dealroomPages {
        id
        pageNum
        editorBlock {
          ...editorBlockViewFragment
        }
      }
    }
    ${editorBlockViewFragment}
  `;

  static loadRevisions = gql`
    query DsrRevisions {
      document {
        documentRevisions {
          message
          revision
          status
          createdAt
          viewedByRecipient
          editorBlockContentVersions {
            blockId
            contentId
          }
        }
      }
    }
  `;

  static loadParticipants = gql`
    query Participants {
      participants {
        id
        role
        userId
        contactId
        details {
          email
          firstName
          lastName
          phone
          title
          companyName
          companyNumber
          thumbUrl
        }
      }
    }
  `;

  static theme = gql`
    query Theme($documentId: String!) {
      theme(documentId: $documentId) {
        name
        backgroundColor
        backgroundImage
        backgroundType
        textColor
        accentColor
        fontSize
        fontFamily
        customCss
        logoUrl
        signButtonText
      }
    }
  `;

  static loadUniversalLink = gql`
    query loadUniversalLink {
      getUniversalLinks {
        url
      }
    }
  `;
}
